import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {
  FormFeedback,
  Button,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
} from "reactstrap";
export default function OtpModal(props) {
  const { toggleLoginModal, loginModal, doLogin, email } = props;
  const [otp, setOtp] = useState("");
  const [otpValidated, setOtpValidated] = useState(undefined);
  const otpInputRef = useRef(null);
  function handleOtpChange(e) {
    setOtp(e.target.value);
  }
  async function handleConfirmOtp(event) {
    if (otp.length !== 6) return;
    const response = await axios.post(
      "/multi_factor_authentication/validatePasscode",
      {
        email: email,
        otp: otp,
      }
    );
    if (response.status === 200) {
      if (response.data) {
        doLogin(event);
      } else {
        setOtp("");
      }
      setOtpValidated(response.data);
    }
  }
  useEffect(() => {
    // Focus OTP input when modal opens
    if (loginModal) {
      // Using setTimeout to ensure DOM is fully rendered
      setTimeout(() => {
        if (otpInputRef.current) {
          otpInputRef.current.focus();
        }
      }, 0);
    }
  }, [loginModal]);
  
  return (
    <Modal isOpen={loginModal} toggle={toggleLoginModal}>
      <ModalHeader toggle={toggleLoginModal}>
        Please Enter your 6 digit OTP from Google Authenticator
      </ModalHeader>
      <ModalBody>
        <Input
          id="otp"
          className="input-transparent pl-3"
          value={otp}
          onChange={(event) => handleOtpChange(event)}
          name="otp"
          placeholder="6 Digit OTP"
          invalid={otpValidated === false}
          valid={otpValidated}
          innerRef={otpInputRef}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && otp.length === 6 && !otpValidated) {
              e.preventDefault();
              handleConfirmOtp(e);
            }
          }}
        />
        {/* {otpValidated !== undefined && otpValidated === false ? ( */}
        <FormFeedback invalid>Invalid OTP. Please try again.</FormFeedback>
        <FormFeedback valid>OTP Validation Success. Logging In.</FormFeedback>
        {/* ) : null} */}
      </ModalBody>
      <ModalFooter>
        {otp.length === 6 && !otpValidated ? (
          <Button color="secondary" onClick={handleConfirmOtp}>
            Confirm OTP
          </Button>
        ) : null}
      </ModalFooter>
    </Modal>
  );
}
